import { render } from "./TheCouponThumbnail.vue?vue&type=template&id=512c6ff6&scoped=true"
import script from "./TheCouponThumbnail.vue?vue&type=script&lang=js"
export * from "./TheCouponThumbnail.vue?vue&type=script&lang=js"

import "./TheCouponThumbnail.vue?vue&type=style&index=0&id=512c6ff6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-512c6ff6"

export default script